var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"shortkey",rawName:"v-shortkey",value:(_vm.shortkeys),expression:"shortkeys"}],staticStyle:{"display":"none"},on:{"shortkey":_vm.action}})}
var staticRenderFns = []

export { render, staticRenderFns }